module.exports = __webpack_public_path__ + "images/createListBg.ca6f10ae.svg";